<template>
  <div class="case-search-com">
    <!--<div class="search-btn" @click="setHistory({inputContext:keWords,page:1,searchType:2})"></div>-->
    <input type="text" @focus="$emit('on-focus',true)" placeholder="输入你要查询的关键词" v-model="keyWords"/>
  </div>
</template>

<script>
  let timer = null
  export default {
    name: 'caseSearchCom',
    data () {
      return {
        keyWords: ''
      }
    },
    watch: {
      keyWords (val) {
        clearInterval(timer)
        timer = setTimeout(() => {
          this.$emit('getSearch', val)
        }, 500)
      }
    },
    computed: {},
    created () {
    },
    mounted () {
    },
    methods: {
      setHistory (data) {
        let historys = localStorage.getItem('historyRechord')
        if (this.keyWords) {
          if (!historys) {
            historys = [this.keyWords]
          } else {
            historys = JSON.parse(historys)
            historys.unshift(this.keyWords)
            historys = new Set(historys)
          }
          localStorage.setItem('historyRechord', JSON.stringify(historys))
        }
        // this.setScreenObj({ brand: {}, category: {}, symptom: {} })
        this.getSearch(data)
      },
      getSearch (data, fn) {
        // const { page } = data
      //   Case.getSearch(data)
      //     .then( res=> {
      //       if(res.code == 200){
      //         if(fn && typeof fn == 'function'){
      //           fn()
      //         }
      //         this.$emit('on-focus',false)
      //         this.$emit("on-search",res.data,page)
      //       }
      //     })
      }
    }
  }
</script>

<style lang="scss" scoped>
.case-search-com{
  padding: 14px 30px 14px 94px;
  height: 40px;
  background:$white-color url("/images/case/search_icon.png") no-repeat 30px center;
  background-size: 40px;
  border:2px solid #e4e4e4;
  border-radius:36px;
  input{
    width: 100%;
    height: 40px;
    line-height: 40px;
  }
}
</style>
